import { useFormContext } from 'react-hook-form';
import { Create, FormDataConsumer, Datagrid, DateField, Edit, List, ReferenceInput, SelectInput, Show, Tab, TabbedShowLayout, TextField, TextInput, TabbedForm, FormTab, ArrayInput, SimpleFormIterator, DateInput, ImageInput, BooleanInput, NumberInput, ImageField, Filter, AutocompleteInput, useDataProvider, CheckboxGroupInput, RadioButtonGroupInput, FunctionField, ShowButton, EditButton, useSourceContext } from 'react-admin';
import React, { Fragment } from "react";
import ListPagination from "../uiComponents/ListPagination";
import { CustomToolbar, FamilyForm, formatPic, PersonalFormContent, PlaceFormContent, RecordAutocompleteInput } from "../helpers/commonForms";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import familyRelationshipData from "../helpers/familyRelationshipData";
import { RichTextInput } from "ra-input-rich-text";

import VisitSummery from "../components/visitSummery";

import AutoCompleteFreeInput from "../uiComponents/AutoCompleteFeeInput";
import ClassificationField from "../uiComponents/classificationField";
const VisitFilter = (props) => (
    <Filter {...props}>
        {/*<TextInput label="Search by Registration ID" source="registrationId" alwaysOn />*/}

        <RecordAutocompleteInput label="Search Record" source="record" alwaysOn emptyText="All Records" />

        <SelectInput alwaysOn emptyText="All Classes"   source="category" label='Class Category' choices={[
            {id: "A", name: 'A - Can Manage without Finado'},
            {id: "B", name: "B - Can Manage only with Finado's Help"},
            {id: "C", name: "C Can't Manage even with finado's Help"},
        ]}/>
        <BooleanInput label="Official" source="official" />
    </Filter>
)


const list = props => <List filters={<VisitFilter/>}  perPage={50}  {...props}  pagination={<ListPagination />} sort={{ field: 'id', order: 'DESC' }}>
    <Datagrid rowClick='show'>
        {/*<TextField source="id" />*/}
        <TextField source="registrationId"  />
        {/*<TextField source="fullName"/>*/}
        {/*<FunctionField label="Outstanding" render={record => <MultiCurrency value={record.disburesedAmount-record.repayedAmount}/>} />*/}

        <FunctionField label="Full Name"  render={record =><>{record.name} {record.fatherName}</>} />


        <DateField label="Visited On" source="date"/>

        <ClassificationField label="Classification" source='category' />
        {/*<TextField label="Classification" source='category' />*/}

        <ShowButton/>
        <EditButton/>

    </Datagrid>
</List>

const VisitTabContent = props => {
    const { setValue } = useFormContext();
    const dataProvider = useDataProvider();
   const onSelected = (id) => {
      // console.log(ev)
       dataProvider.getOne('Record', { id})
           .then(({ data }) => {



             //  console.log(data)
               setValue('name',data.name)
               setValue('registrationId',data.registrationId)
               setValue('fatherName',data.fatherName)
               setValue('gFatherName',data.gFatherName)
               setValue('gender',data.gender)
               setValue('birthDate',data.birthDate)
               setValue('placeOfBirth',data.placeOfBirth)
               setValue('health',data.health)
               setValue('currentEducation',data.currentEducation)
               setValue('photo',data.photo)
               setValue('address',data.address)
               setValue('families',data.families)
               setValue('story',data.story)
               setValue('place',data.place)

                   setValue('expense.schoolFees',[data.currentEducation&&{
                       nameOfChild: data.name,
                       school:data.currentEducation
                   },...data.families.flatMap(f=>{
                       if(f.currentEducation&&f.currentEducation.status==="On Going"){
                           return [{
                               nameOfChild: f.name,
                               school:f.currentEducation
                           }]
                       }
                       return []
                   })])
               setValue('income.familyIncomes',[...data.families.flatMap(f=>{
                   if(f.isIncomeProvider){
                       return [{
                           providerName:f.name,
                           relationship:f.relationship,
                           description:f.proffession,
                           income:f.monthlyIncome,

                         }]
                   }
                   return []
               })])

           })
   }

    return <>
        <ArrayInput  source='takenBy'>
            <SimpleFormIterator>
                <TextInput label="Staff Name" source='name'/>
            </SimpleFormIterator>
        </ArrayInput>
        <DateInput label='Visit Date' source='date' />
        <ReferenceInput filterToQuery={searchText => {}} label="Finado Child" source="record" reference="Record" perPage={1000}>
            <AutocompleteInput onChange={ev=>onSelected(ev)} optionText={choice=>`${choice.name} ${choice.fatherName} - ${choice.registrationId}`} />
        </ReferenceInput>
        <TextInput source='registrationId' />
    </>
}

// Defined but not referenced anywhere. Kept, commented out, rather
// than deleted: it is a tab wrapper that may have been intended for
// the form and is easy to reinstate.
// const VisitFromTab = props => {
//     return <FormTab {...props} label='Visit'>
//         <VisitTabContent {...props}/>
//     </FormTab>
// }

const VisitForm = props => <TabbedForm toolbar={<CustomToolbar tabs={8}   {...props} />} {...props} onChange={e=>console.log(e)} initialValues={{takenBy:[{name:''}]}}>

    <FormTab label="Visit">
        <VisitTabContent/>
    </FormTab>

    <FormTab label="Personal">
        <FormDataConsumer>
            {formDataProps => (
                <PersonalFormContent {...formDataProps}/>
            )}
        </FormDataConsumer>
    </FormTab>
    <FormTab   label="Family">
        <ArrayInput label='Family Member'  source="families">
            <SimpleFormIterator  >


                <FormDataConsumer>
                    {formDataProps => (
                        <FamilyForm {...formDataProps}  />
                    )}
                </FormDataConsumer>


                {/*<Box display="flex" style={{width:"100%"}}>*/}
                {/*    */}
                {/*<TextInput label="Health Condition"  source="health.generalCondition" />*/}
                {/*<TextInput label="Health Remark"  source="health.remark" />*/}
                {/*</Box>*/}

            </SimpleFormIterator>
        </ArrayInput>
    </FormTab>
    <FormTab label="Place">
        <FormDataConsumer>
            {formDataProps => (
                <PlaceFormContent {...formDataProps}/>
            )}
        </FormDataConsumer>
    </FormTab>
    <FormTab label='Expenses'>
        <Typography  variant="h6" gutterBottom>School Expenses</Typography>
        <ArrayInput label='School Fees'  source="expense.schoolFees">
            <SimpleFormIterator  >
                <TextInput label='Name of Child' source='nameOfChild' />

                <SelectInput label="Level"  source="school.level" choices={[
                    {id: "Elementary", name: 'Elementary'},
                    {id: "High School", name: 'High School'},
                    {id: "Higher Education", name: 'Higher Education'},
                ]}/>
                <SelectInput label="School Type"   source="school.schoolType" choices={[
                    {id: "Government", name: 'Government'},
                    {id: "Private", name: 'Private'},
                ]}/>
                <NumberInput step={0}  label='Fee' source='fee' />
            </SimpleFormIterator>
        </ArrayInput>

        <Typography  variant="h6" gutterBottom>Rent Expense</Typography>
        <Grid container style={{width:"100%"}}>
            <Grid item>
                <SelectInput label="House Type"  source="expense.rent.houseType" choices={[
                    {id: "Very Small", name: 'Very Small'},
                    {id: "Small", name: 'Small'},
                    {id: "Medium", name: 'Medium'},
                    {id: "Large", name: 'Large'},
                ]}/>
            </Grid>
            <Grid item>
                <NumberInput step={0}  label='Fee' source='expense.rent.fee' />
            </Grid>
        </Grid>

        <ImageInput format={ formatPic } source="expense.rent.photo" label="House Picture" accept={{ 'image/*': [] }} placeholder={<p>Drop your file here</p>}>
            <ImageField source="src" title="title" />
        </ImageInput>
        <Typography  variant="h6" gutterBottom>Utility Expenses</Typography>
        <ArrayInput  label='Utility Expenses'  source="expense.utilityExpenses">
            <SimpleFormIterator  >

                {/*<SelectInput  label="Utility"  source='type' choices={[*/}
                {/*    {id: "Water", name: 'Water'},*/}
                {/*    {id: "Electricity", name: 'Electricity'},*/}
                {/*    {id: "Gas", name: 'Gas'},*/}
                {/*    {id: "Wood", name: 'Wood'},*/}
                {/*    {id: "Other", name: 'Other'},*/}
                {/*]}/>*/}

                <AutoCompleteFreeInput  label="Utility"  source='name' choices={[
                    {id: "Water", name: 'Water'},
                    {id: "Electricity", name: 'Electricity'},
                    {id: "Gas", name: 'Gas'},
                    {id: "Wood", name: 'Wood'},
                        ]}/>
                {/*<TextInput label='name' source='name' />*/}
                <TextInput label='Remark' source='remark' />
                <NumberInput step={0}  label='Last Month Fee' source='lastFee' />
                <NumberInput  step={0}  label='Average Fee' source='fee' />
            </SimpleFormIterator>
        </ArrayInput>

        <Typography  variant="h6" gutterBottom>Medical Expenses</Typography>
        <ArrayInput label='Medical Expenses'   source="expense.medicalExpenses">
            <SimpleFormIterator  >
                <SelectInput  label="Relationship" source='relationship' choices={familyRelationshipData} />
                <TextInput label='Medical Condition/Description' source='description' />
                <BooleanInput label='Unable to Work' source='unableToWork' />
                <NumberInput step={0}  label='Fee' source='fee' />
                <TextInput label='Remark' source='remark'/>
            </SimpleFormIterator>
        </ArrayInput>

        <Typography  variant="h6" gutterBottom>Basic Food Expenses</Typography>
        <ArrayInput label='Food Expenses'   source="expense.foodExpenses">
            <SimpleFormIterator  >

                <FormDataConsumer>
                    {formDataProps => <FoodItemsForm {...formDataProps}/>}
                </FormDataConsumer>/


            </SimpleFormIterator>
        </ArrayInput>

        <Typography  variant="h6" gutterBottom>Other  Expenses</Typography>
        <ArrayInput label='Other Expenses'   source="expense.otherExpenses">
            <SimpleFormIterator  >
                <TextInput label='description' source='description' />
                <NumberInput step={0}  label='fee' source='fee' />
                <BooleanInput label='Is Necessary' source='necessary '/>
            </SimpleFormIterator>
        </ArrayInput>


    </FormTab>
    <FormTab label='Income'>
        <Typography  variant="h6" gutterBottom>Income From Family Members</Typography>
        <ArrayInput label='Family Income'   source="income.familyIncomes">
            <SimpleFormIterator  >
                <TextInput label='Provider Name' source='providerName' />
                <SelectInput  label="Relationship" source='relationship' choices={familyRelationshipData} />
                <TextInput label='Work Description' source='description' />
                <TextInput label='Work Place' source='workPlace' />
                <NumberInput label='Income' source='income' />

            </SimpleFormIterator>
        </ArrayInput>
        <Typography  variant="h6" gutterBottom>Other  Income Means</Typography>
        <ArrayInput label='Other Incomes'   source="income.otherIncomes">
            <SimpleFormIterator  >
                <TextInput label='Description' source='description' />

                <NumberInput step={0}  label='Income' source='income' />
                <TextInput label='Remark' source='remark' />
            </SimpleFormIterator>
        </ArrayInput>
    </FormTab>
    <FormTab label='Assets / Living Conditions'>
        <CheckboxGroupInput label='Common Assets' source="asset.commonAssets" choices={[
            { id: 'OtherFurniture', name: 'Other Furniture' },
            { id: 'Sofa', name: 'Sofa' },
            { id: 'Tv', name: 'TV' },
            { id: 'Refrigerator', name: 'Refrigerator' },
        ]} />
        <ArrayInput label='Other Notable Assets'   source="asset.otherAssets">
            <SimpleFormIterator  >
                <TextInput label='Description' source='description' />
                <BooleanInput label='Expensive' source='isExpensive' />
                <BooleanInput label='Necessary' source='isNecessary' />

            </SimpleFormIterator>
        </ArrayInput>

        <CheckboxGroupInput label='Utilities' source="livingCondition.utilities" choices={[
            { id: 'PrivateSanitary', name: 'Private Sanitary' },
            { id: 'PublicSanitary', name: 'Public Sanitary' },
            { id: 'PublicWater', name: 'Public Water' },
            { id: 'TapWater', name: 'Tap Water' },
            { id: 'Electric', name: 'Electric City' },
        ]} />

        <RichTextInput label='Remark About living condition' source='livingCondition.remark' />
        <ImageInput multiple={true} format={ formatPic } source="livingCondition.photos" label="Pictures" accept={{ 'image/*': [] }} placeholder={<p>Drop your file here</p>}>
            <ImageField source="src" title="title" />
        </ImageInput>
    </FormTab>
    <FormTab label="Result">
        <FormDataConsumer>
            {formDataProps => (
                <ResultFormContent {...formDataProps}/>
            )}
        </FormDataConsumer>
    </FormTab>


</TabbedForm>


const ResultFormContent = props => {
    const { setValue } = useFormContext();
    const {formData} = props;
    //console.log(props)
    //console.log(formData)
    const calculateTotalExpense = (expense) => {
        const schoolFees = expense.schoolFees && expense.schoolFees.reduce((sum,cv)=>cv && sum+cv.fee,0)
        const otherExpenses = expense.otherExpenses && expense.otherExpenses.reduce((sum,cv)=>cv && sum+cv.fee,0)
     //   return schoolFees + otherExpenses
        const foodExpenses = expense.foodExpenses &&  expense.foodExpenses.reduce((sum,cv)=>cv && sum+cv.fee,0)

        const  utilityExpenses  = expense.utilityExpenses &&  expense.utilityExpenses.reduce((sum,cv)=>cv && sum+cv.fee,0)
        const medicalExpenses = expense.medicalExpenses &&  expense.medicalExpenses.reduce((sum,cv)=>cv && sum+cv.fee,0)
        const houseRent = expense.rent && expense.rent.fee
        return (schoolFees || 0) + (otherExpenses || 0) + (foodExpenses || 0) + (utilityExpenses ||0 ) + (medicalExpenses || 0) + (houseRent || 0)
       // return schoolFees + medicalExpenses + utilityExpenses + medicalExpenses + houseRent;
    }
const calculateTotalIncome = (income) =>{
   const familyIncome = income.familyIncomes && income.familyIncomes.reduce((sum,cv)=>cv && sum+cv.income,0)
  const otherIncome = income.otherIncomes && income.otherIncomes.reduce((sum,cv)=>cv && sum+cv.income,0)
 return (familyIncome || 0) + (otherIncome || 0)
}
if(!(formData.result && formData.result.expenseEdited)) {

    setValue('result.estimatedExpense', formData.expense && calculateTotalExpense(formData.expense))


}
    if(!(formData.result && formData.result.incomeEdited)) {
      setValue('result.estimatedIncome', formData.income && calculateTotalIncome(formData.income) )
        // setValue('result.trueIncome', formData.income && calculateTotalIncome(formData.income) )

    }


    return   <>
        <Grid container spacing={2} style={{width:"100%"}}>
            <BooleanInput label='Edit' source='result.expenseEdited'/>
            <NumberInput disabled={!(formData.result && formData.result.expenseEdited)}  label='Total Estimated Expense' source='result.estimatedExpense' />
            <NumberInput onChange={e=>{
                setValue('result.remainingIncome', formData.result && ((formData.result.totalIncome || 0) - (+e.target.value || 0)))
            }} label='Total Necessary Expence' source='result.necessaryExpense' />
            <TextInput label='Expense Remark' source='result.expenseRemark' />
        </Grid>
        <Grid container style={{width:"100%"}}>
            <BooleanInput label='Edit' source='result.incomeEdited'/>
            <NumberInput disabled={!(formData.result && formData.result.incomeEdited)} label='Total Income' source='result.estimatedIncome' />
            <NumberInput onChange={e=>{
                setValue('result.totalIncome', formData.result && (+e.target.value+ (formData.result.finadoFund||0)))
        //        setValue('result.trueIncome', formData.result && (+e.target.value+ (formData.result.finadoFund||0)))
                setValue('result.remainingIncome', formData.result && (+e.target.value+ (formData.result.finadoFund||0) - (formData.result.necessaryExpense || 0)))

            }} label='True Income' source='result.trueIncome' />
            <TextInput label='Income Remark' source='result.incomeRemark' />
        </Grid>


            <Grid  container direction='column' style={{width:"50%"}}  >
                <Grid item>
                    <NumberInput onChange={e=>{
                        setValue('result.totalIncome', formData.result && (+e.target.value+ (formData.result.trueIncome||0)))
                        // setValue('result.remainingIncome', formData.result && (+e.target.value+ (formData.result.finadoFund||0) - (formData.result.necessaryExpense || 0)))

                        setValue('result.remainingIncome', formData.result && (+e.target.value+ (formData.result.trueIncome||0) - (formData.result.necessaryExpense || 0)))
                    }} fullWidth  label='Current Finado Fund (For all sponsored)' source='result.finadoFund' />

                </Grid>
                <Grid item>
                    <NumberInput disabled fullWidth label='Total Income (True Income + Finado Fund)' source='result.totalIncome' />
                </Grid>
                <Grid item>
                    <NumberInput disabled  label='Remaining' source='result.remainingIncome' />
                    <TextInput label='Remaining Remark' source='result.remainingRemark' />
                </Grid>
            </Grid>
            <Grid  container direction='column' style={{width:"50%"}} >
                <Grid item>
                    <Typography  variant="h6" gutterBottom>Conclusion Based on the above results</Typography>
                    <RadioButtonGroupInput source="category" choices={[
                        { id: 'A', name: 'Can Mange without Finado' },
                        { id: 'B', name: ' Can manage only with Finado’s fund' },
                        { id: 'C', name: 'can’t manage even with Finado’s fund' },
                    ]} />
                </Grid>

            </Grid>

        <Typography  variant="h6" gutterBottom>Motivation of the ranking (apart from the above results )</Typography>
        <RichTextInput source='motivation' label='Motivation' />

        <ArrayInput label='Photos' source="visitPhotos">

            <SimpleFormIterator  >
                {/*<TextInput source="filePath" />*/}
                <ImageInput format={ formatPic } source="filePath" label="Photo" accept={{ 'image/*': [] }} placeholder={<p>Drop your file here</p>}>
                    <ImageField source="src" title="title" />
                </ImageInput>

                    <TextInput label='Title' source="title" />
                    {/*<DateInput label='Date' source="date"  options={{ format: 'DD/MM/YYYY' }}/>*/}
                    <TextInput multiline label='Description' source="description" />



            </SimpleFormIterator>
        </ArrayInput>
    </>


}

// Defined but not referenced anywhere. Kept, commented out, rather
// than deleted: it is a tab wrapper that may have been intended for
// the form and is easy to reinstate.
// const ResultForm = props => {
//     return <FormTab {...props} label='Result'>
//         <ResultFormContent {...props}/>
//     </FormTab>
// }
const create = (props) => <Create {...props}>
    <VisitForm/>
</Create>

const edit = props => <Edit {...props} >
  <VisitForm/>
</Edit>

const show = props => <Show {...props} queryOptions={{ refetchOnMount: true }} >
    <TabbedShowLayout>
        <Tab  label="Summery">
            <VisitSummery/>
        </Tab>
    </TabbedShowLayout>
</Show>

const FoodItemsForm = ({scopedFormData, ...rest }) => {
    const { setValue } = useFormContext();
    const sourceContext = useSourceContext();
    const src = sourceContext ? sourceContext.getSource : (s) => s;
    return <Fragment>
        <AutoCompleteFreeInput label='Food Item' source="name" choices={[
            {id: "Onion", name: 'Onion'},
            {id: "Teff", name: 'Teff'},
            {id: "Oil", name: 'Oil'},
            {id: "Shiro", name: 'Shiro'},
            {id: "Berbere", name: 'Berbere'},
        ]}/>

        <NumberInput step={0}  label='Usage' source="usage" onChange={ev=> setValue(src("fee"), ev.target.value*((scopedFormData && scopedFormData.unitPrice)||0))} />
        <AutoCompleteFreeInput label='Unit' source="unit" choices={[
            {id: "Kgs", name: 'Kgs'},
            {id: "Lts", name: 'Litters'},
        ]}/>
        <NumberInput step={0}  label='Price Per Unit ' source="unitPrice" onChange={ev=> setValue(src("fee"), ev.target.value*((scopedFormData && scopedFormData.usage)||0))} />
        <NumberInput  step={0}  label='fee' source="fee" />
    </Fragment>
}


const Visit = {create, list, show, edit}

export default Visit;
